// ui-handler.js
function updatePanelPositions(spacing, angle, depth) {
    const leftPanel = document.getElementById("large-left-panel");
    const centerPanel = document.getElementById("large-center-panel");
    const rightPanel = document.getElementById("large-right-panel");

    // Adjust positions dynamically
    leftPanel.setAttribute("position", `${-spacing} 1.6 ${-depth}`);
    leftPanel.setAttribute("rotation", `0 ${angle} 0`);

    centerPanel.setAttribute("position", `0 1.725 -1.11`);
    centerPanel.setAttribute("rotation", `0 0 0`);

    rightPanel.setAttribute("position", `${spacing} 1.6 ${-depth}`);
    rightPanel.setAttribute("rotation", `0 ${-angle} 0`);
}

function minimizePanel(panelId) {
    const scene = document.getElementById('main-scene');
    const panel = document.getElementById(panelId);
    const dock = document.getElementById("dock");
    if (!panel || !dock) {
        console.error(`Minimize failed: panel=${panel}, dock=${dock}`);
        return;
    }

    const minimizedPanels = Array.from(scene.children).filter(child =>
        child.hasAttribute('ui-button-state') &&
        child.getAttribute('ui-button-state').isMinimized
    );
    const dockIndex = minimizedPanels.length;
    console.log(`minimizedPanels ${dockIndex}`);

    const originalPosition = panel.getAttribute("position");
    const originalScale = panel.getAttribute("scale") || { x: 1, y: 1, z: 1 };
    const originalRotation = panel.getAttribute("rotation") || { x: 0, y: 0, z: 0 };
    panel.setAttribute('ui-button-state', {
        originalPosition: originalPosition,
        originalScale: originalScale,
        originalRotation: originalRotation,
        isMinimized: true,
        dockIndex: 0
    });

    const dockPosition = dock.getAttribute("position");
    const dockVisual = document.getElementById('dock-visual');
    const dockWidth = dockVisual.getAttribute("width") || 2.0;
    const dockHeight = dockVisual.getAttribute("height") || 0.3;
    const dockLeftEdge = dockPosition.x;
    const dockYBottom = dockPosition.y;
    const dockX = dockLeftEdge + (dockIndex * 0.15) + 0.1;
    const dockY = dockYBottom + 0.056;
    const dockZ = dockPosition.z + 0.01;
    const dockSlotPosition = `${dockX} ${dockY} ${dockZ}`;
    panel.setAttribute('ui-button-state', 'dockIndex', dockIndex);

    const startX = originalPosition.x;
    const startY = originalPosition.y;
    const startZ = originalPosition.z;

    panel.setAttribute("animation__genieMinimize", {
        property: "scale",
        to: "0.08 0.08 0.08",
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "minimizeStart"
    });
    panel.setAttribute("animation__moveToDock", {
        property: "position",
        from: `${startX} ${startY} ${startZ}`,
        to: dockSlotPosition,
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "minimizeStart"
    });
    panel.setAttribute("animation__rotateToDock", {
        property: "rotation",
        to: "0 0 0",
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "minimizeStart"
    });

    panel.addEventListener('animationcomplete__moveToDock', () => {
        console.log(`Panel ${panelId} minimized to ${dockSlotPosition}`);
        panel.setAttribute('position', dockSlotPosition);
        panel.setAttribute('visible', true);
        panel.object3D.visible = true;
        Array.from(panel.children).forEach(child => {
            child.setAttribute('visible', true);
            child.object3D.visible = true;
        });

        // Add overlay after minimization
        const overlay = document.createElement('a-plane');
        overlay.setAttribute('id', `${panelId}-overlay`);
        const bbox = new THREE.Box3().setFromObject(panel.object3D);
        const size = new THREE.Vector3();
        bbox.getSize(size);
        const minimizedWidth = size.x * 1.1;
        const minimizedHeight = size.y * 1.1;
        overlay.setAttribute('width', minimizedWidth);
        overlay.setAttribute('height', minimizedHeight);
        overlay.setAttribute('position', `${dockX} ${dockY} ${dockZ + 0.01}`);
        overlay.setAttribute('material', 'opacity: 0; transparent: true');
        overlay.setAttribute('data-raycastable', '');
        overlay.setAttribute('docked-panel', ''); // Moved to overlay
        scene.appendChild(overlay);

        panel.removeAttribute("animation__genieMinimize");
        panel.removeAttribute("animation__moveToDock");
        panel.removeAttribute("animation__rotateToDock");
    }, { once: true });

    console.log(`Starting minimize for ${panelId}`);
    panel.emit("minimizeStart");
}

function restorePanel(panelId) {
    const scene = document.getElementById('main-scene');
    const panel = document.getElementById(panelId);
    if (!panel) return;

    const state = panel.getAttribute('ui-button-state');
    if (!state || !state.isMinimized) return;
    const { originalPosition, originalScale, originalRotation, dockIndex } = state;

    // Remove overlay (which has docked-panel)
    const overlay = document.getElementById(`${panelId}-overlay`);
    if (overlay) scene.removeChild(overlay);

    const dock = document.getElementById("dock");
    const dockPosition = dock.getAttribute("position");
    const dockVisual = dock.querySelector('#dock-visual');
    const dockHeight = dockVisual.getAttribute("height") || 0.3;
    const dockYCenter = dockPosition.y + (dockHeight / 2);

    const startX = dockPosition.x + 0.2 + (dockIndex * 0.3);
    const startY = dockYCenter;
    const startZ = dockPosition.z;
    const endX = originalPosition.x;
    const endY = originalPosition.y;
    const endZ = originalPosition.z;

    panel.setAttribute("animation__genieRestore", {
        property: "scale",
        to: `${originalScale.x} ${originalScale.y} ${originalScale.z}`,
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "restoreStart"
    });
    panel.setAttribute("animation__moveFromDock", {
        property: "position",
        from: `${startX} ${startY} ${startZ}`,
        to: `${endX} ${endY} ${endZ}`,
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "restoreStart"
    });
    panel.setAttribute("animation__rotateFromDock", {
        property: "rotation",
        to: `${originalRotation.x} ${originalRotation.y} ${originalRotation.z}`,
        dur: 600,
        easing: "easeInOutQuad",
        startEvents: "restoreStart"
    });

    panel.addEventListener('animationcomplete__moveFromDock', () => {
        console.log(`Panel ${panelId} restored from dock`);
        panel.setAttribute('position', `${endX} ${endY} ${endZ}`);
        panel.setAttribute('visible', true);
        panel.object3D.visible = true;
        Array.from(panel.children).forEach(child => {
            child.setAttribute('visible', true);
            child.object3D.visible = true;
        });
        panel.setAttribute('ui-button-state', 'isMinimized', false);
        panel.removeAttribute("animation__genieRestore");
        panel.removeAttribute("animation__moveFromDock");
        panel.removeAttribute("animation__rotateToDock");
    }, { once: true });

    console.log(`Starting restore for ${panelId}`);
    panel.emit("restoreStart");
}

// State component
AFRAME.registerComponent('ui-button-state', {
    schema: {
        originalPosition: { type: 'vec3' },
        originalScale: { type: 'vec3', default: { x: 1, y: 1, z: 1 } },
        originalRotation: { type: 'vec3', default: { x: 0, y: 0, z: 0 } },
        isMinimized: { type: 'boolean', default: false },
        dockIndex: { type: 'int', default: 0 }
    }
});

// Dock panel click handler
AFRAME.registerComponent('docked-panel', {
    init: function () {
        this.el.addEventListener('click', () => {
            const panelId = this.el.id.replace('-overlay', ''); // Extract panel ID
            restorePanel(panelId);
        });
    }
});